import React, { FC } from 'react';
import { Button } from 'antd';
import { Image } from 'common/components';
import emptyState from 'app/assets/images/redesign/empty-state-2.svg';

interface IComponentProps {
  title: string;
  description?: string;
  btnTitle?: string;
  onClick?: () => void;
}

export const EmptyState: FC<IComponentProps> = ({ title, description, btnTitle, onClick }) => {
  return (
    <div className="flex align-center justify-center flex-1 empty-state">
      <div className="flex align-center empty-state__wrapper">
        <Image size={120} src={emptyState} />

        <div className="flex-1 text-start empty-state__container">
          <div className="mb-3 ff-regular fs-l color-black empty-state__text">{title}</div>

          {description && <div className="ff-regular fs-s color-dark-grey empty-state__text">{description}</div>}

          {btnTitle && onClick && (
            <Button className="button-sm secondary mt-6" onClick={onClick}>
              {btnTitle}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
